<div [hidden]="HideComponent">
  <div [hidden]="HideSearch">
    <div class="row-no-margin section-header-container">
      <div class="col-md-6 clear-padding">
        <span class="section-header">Quick Price Lookup</span>
        <mat-form-field *ngIf="CurrentUser.IsTolomaticUser" appearance="fill">
          <mat-label>Distributor:</mat-label>
          <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [value]="CurrentDist.CompanyId">
            <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
              {{dist.Company}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 clear-padding">

      </div>
    </div>

    <div class="pricing-section">
      <span class="darkblue-label">ENTER AN 8 DIGIT ITEM OR CONFIGURED STRING</span>

      <br />

      <input placeholder="########" [(ngModel)]="ConfigString" (keyup.enter)="PriceItem(ConfigString)" style="width:70%;" type="text" class="with-button" />
      <fa-icon [icon]="faSearch" (click)="SearchForItem()" style="padding-right:15px;margin-left:-31px;" class="clickable blue-color"></fa-icon>
      <button (click)="PriceItem(ConfigString)" class="with-input blue">PRICE</button>
      <br />
      <span [hidden]="!InvalidItem" class="red">Invalid Item Number/Incomplete Config String</span>

    </div>
    <!--<div class="pricing-section">
      <span class="darkblue-label">QUANTITY</span>
      <br />
      <input placeholder="0" [(ngModel)]="Quantity" type="number" min="0" />
    </div>-->
    <div class="pricing-section">
      <span class="darkblue-label">DETAILED ITEM PRICING</span>
      <br />
      <button (click)="CreateNewConfig(null)" class="blue">BUILD ITEM</button>
    </div>
  </div>
  <div [hidden]="!HideSearch">
    <span (click)="BackToSearch()" class="clickable">&lt; Edit Search</span>
    <br />
    <app-price-break [hidden]="!ShowBreakPrice" [ItemPriceList]="ItemList" [Customer]="CurrentDist" [OverridePricingRule]="OverrideBreakPricingRule"></app-price-break>
    <!--<div [hidden]="ShowBreakPrice">
      <table class="pricing-table" style="width:100%;">
        <tr>
          <th>Config String</th>
          <th style="text-align:center;">Quantity</th>
          <th style="text-align:center;">List Price</th>
          <th style="text-align:center;">Total</th>
        </tr>
        <tr>
          <td class="small-content">
            <span class="medium-content">{{ConfigString}}</span>
          </td>
          <td style="text-align:center;"><input type="number" [(ngModel)]="Quantity" min="0" /></td>
          <td style="text-align:center;">
            <span>{{ConfiguredPrice | currency}}</span>
          </td>
          <td style="text-align:center;">{{Quantity * ConfiguredPrice | currency}}</td>
        </tr>
      </table>
    </div>-->
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
</div>
